import React from 'react'
import './footer.css'
import omitLogo from '../../assets/logo.svg'

const Footer = () => {
  return (
    <div className='omit__footer section__padding'>
      <div className='omit__footer-heading'>
        <h1 className='gradient__text'>
          Do you want to step in to the future before others
        </h1>
      </div>

      <div className='omit__footer-btn'>
        <p>Get Pricing</p>
      </div>

      <div className='omit__footer-links'>
        <div className='omit__footer-links_logo'>
          <img src={omitLogo} alt='logo' />
          <p>Oreyeshood O34 182 DK Alknjkcb</p>
        </div>
        <div className='omit__footer-links_div'>
          <h4>Links</h4>
          <p>Social Media</p>
          <p>Counters</p>
          <p>Contact</p>
        </div>
        <div className='omit__footer-links_div'>
          <h4>Company</h4>
          <p>Terms & Conditions</p>
          <p>Privacy Policy</p>
          <p>Contact</p>
        </div>
        <div className='omit__footer-links_div'>
          <h4>Oreyeshood O34 182 DK Alknjkcb</h4>
          <p>0034-321-132-567</p>
          <p>Social Media</p>
          <p>info@omit.net</p>
        </div>
      </div>
      <div className='omit__footer-copyright'>
        <p>© 2023 OMIT. All rights reserved.</p>
      </div>
    </div>
  )
}

export default Footer
